import styled from "styled-components";

export const TitleWrapper = styled.div`
    margin-top: 2rem;
`;
export const Title = styled.h1`
    font-size: 2.2rem;
    font-family: 'Rubik';
    font-weight: 600;
`;
export const Subtitle = styled.p`
    margin-top: 8px;
    color: #4f525a;
`;

export const StaticContent = styled.div`
    margin: 2rem 0 1rem;
    h2 {
        font-size: 2.2rem;
        font-family: 'Rubik';
        font-weight: 600;
        margin-top: 1rem;
    }
    p {
        padding: 1rem 0;
        color: #4f525a;
    }
    ul {
        list-style-type: disc;
        padding: 0 0 0 2rem;

        li {
            padding: 0.5rem 0 0;
            padding-bottom: 0;

            &:last-child {
            padding-bottom: 0;
            }
            p {
                padding: 0.5rem 0;
                color: #4f525a;
            }
            h2 {
                font-size: 2.2rem;
                font-family: 'Rubik';
                font-weight: 600;
                margin-top: 0.5rem;
            }    
        }
    }
`;

export const DynamicContentCont = styled.div`
    h2 {
        font-size: 1.8rem;
        font-weight: 600;  
    }
    h2 strong {
        font-size: 1.8rem;
        font-weight: 600;
    }
    ul li h2 {
        font-size: 1.8rem;
        font-weight: 600;
    }
`

export const PlaceInformationContent = styled.div`
    h3 {
        font-size: 2.2rem;
        font-weight: 600;
    }
    h2 strong {
        font-size: 1.8rem;
        font-weight: 600;
    }
`